import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bdcca0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "autocomplete-hide",
  type: "text",
  name: "autocompletehide1"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "autocomplete-hide",
  type: "password",
  name: "autocompletehide2"
}, null, -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  class: "spinner-border spinner-border-sm text-light",
  role: "status",
  style: {"margin-right":"0.5rem"}
}

import { reactive, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { authStore } from '@/stores';
  import { useToast } from 'bootstrap-vue-3';
  import { Country } from '@/components/country-selector/countries';

  
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, { emit: emits }) {

  const { t, locale } = useI18n();
  
  const toast = useToast();

  const disabled = ref(false);

  const form = reactive({
    phone_number: '',
    password: '',
    verification_code: '',
  });

  const phoneNumberDialCode = ref<number | undefined>();

  const phoneNumber = computed(() => {
    if (form.phone_number) {
      return String(form.phone_number).startsWith('+') ? form.phone_number : `+${phoneNumberDialCode.value} ${form.phone_number}`;
    }
    return '';
  });

  function formItemChange(data: any) {
    form[data.key] = data.value;
  }

  async function handleSubmitPhoneNumber() {
    try {
      disabled.value = true;
      const body = {
        ...form,
        phone_number: phoneNumber.value,
      };
      await authStore.updatePhoneNumber(body);
      emits('success', body.phone_number);
      toast.show({ title: t('Tips'), body: t('Success') }, { variant: 'success' });
    } finally {
      disabled.value = false;
    }
  }

  function handleGetPhoneNumberCountry(country: Country) {
    phoneNumberDialCode.value = country.dialCode;
  }


return (_ctx: any,_cache: any) => {
  const _component_AppCountrySelector = _resolveComponent("AppCountrySelector")!
  const _component_AppFormGroupItem = _resolveComponent("AppFormGroupItem")!
  const _component_AppVerificationCodeBtn = _resolveComponent("AppVerificationCodeBtn")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createBlock(_component_b_form, {
    style: {"width":"100%"},
    onSubmit: handleSubmitPhoneNumber
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: _unref(t)('PHONE NUMBER FORM LABEL'),
        type: 'input',
        key: 'phone_number',
        required: true,
        placeholder: '01012340000',
      },
        form: _unref(form),
        onChange: formItemChange
      }, {
        inputBefore: _withCtx(() => [
          _createVNode(_component_AppCountrySelector, {
            "country-code": _unref(locale),
            onExcountry: handleGetPhoneNumberCountry
          }, null, 8, ["country-code"])
        ]),
        _: 1
      }, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: _unref(t)('PASSWORD'),
        type: 'input',
        inputType: 'password',
        key: 'password',
        required: true,
        placeholder: '',
        triggerPwd: true
      },
        form: _unref(form),
        onChange: formItemChange
      }, null, 8, ["config", "form"]),
      _createVNode(_component_AppFormGroupItem, {
        config: {
        label: _unref(t)('VERIFICATION CODE'),
        type: 'input',
        key: 'verification_code',
        required: true,
        placeholder: ''
      },
        form: _unref(form),
        onChange: formItemChange
      }, {
        inputAfter: _withCtx(() => [
          _createVNode(_component_AppVerificationCodeBtn, {
            target: _unref(phoneNumber),
            event: "verify_phone_number",
            insert: "half"
          }, null, 8, ["target"])
        ]),
        _: 1
      }, 8, ["config", "form"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_button, {
          type: "submit",
          pill: "",
          variant: "primary",
          disabled: disabled.value,
          class: "submit-btn"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
              [_vShow, disabled.value]
            ]),
            _createTextVNode(" " + _toDisplayString(_unref(t)('Submit')), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _: 1
  }))
}
}

})